<template>
	<div class="chat">
		<div class="timeTip_box">
			<div class="timeTip" v-if="isbrowse">
				注意：对方通过{{ sourceTypeStr }}
				<span v-show="userType == 1">（以访客身份）</span>
				向你发送消息 ，你还有<span v-show="dd">{{ dd }}天</span>{{ hh }}小时{{ mm }}分钟{{
					ss
				}}秒的时间来回复对方
			</div>
		</div>
		<div class="content-box">
			<el-scrollbar style="height: 100%; overflow-x: hidden" ref="myScrollbar">
				<div
					v-if="moreTextFlag"
					:class="[moreText == '暂无更多消息' ? 'greyMoreText' : 'moreText']"
					@click="more"
				>
					{{ moreText }}
				</div>
				<div style="padding: 0px 20px">
					<div v-for="(item, index) in list" :key="item.fbName + index">
						<!-- 接收到他人消息 -->
						<div class="chat-box" v-if="item.senderType == 1">
							<div class="img-container">
								<!-- sendoutType发送类型(1.系统自动回复2.优化师回复3.全球赢后台4.FB后台) -->
								<img
									:src="require('@/assets/chat/sysDefault.png')"
									class="img"
									v-if="item.sendoutType == 1"
								/>
								<img :src="item.fbThumb || require('@/assets/default.png')" class="img" v-else />
							</div>
							<div class="chat-content" v-if="item.contentList && item.contentList.length">
								<div style="height: 18px; font-size: 10px">
									<span>
										{{ item.fbName }}
										<span style="float: right; margin-left: 20px" v-if="checkIndex == index">
											{{ item.sendTime }}
										</span>
									</span>
								</div>
								<!--图片-->
								<div
									class="imgcontent"
									v-if="item.contentList[0].type == 2"
									@mouseenter="mouseenter(index)"
									@mouseleave="mouseleave"
								>
									<div v-if="imgFlag == index">
										<sky-img-preview
											:file="{ url: item.contentList[0].urls, ossName: '8144864489269305344.png' }"
											file-name="AHHAH"
											:visible.sync="dialogVisible"
											title="查看图片"
											:img-url="item.contentList[0].urls"
											@on-cancel="showImg(index, -1)"
											:append="true"
										></sky-img-preview>
									</div>
									<img :src="item.contentList[0].urls" @click="showImg(index)" class="img-box" />
								</div>
								<!-- 视频 -->
								<div
									class="video_box"
									v-else-if="item.contentList[0].type == 3"
									@mouseenter="mouseenter(index)"
									@mouseleave="mouseleave"
								>
									<video
										ref="videoPlayer"
										controls
										:src="item.contentList[0].urls"
										class="video_content"
									></video>
								</div>
								<!-- 文件 -->
								<div
									class="video_box"
									v-else-if="item.contentList[0].type == 4"
									@mouseenter="mouseenter(index)"
									@mouseleave="mouseleave"
								>
									<div>
										<el-row
											class="file_style"
											@click="download(item.contentList[0].urls, item.contentList[0].fileName)"
										>
											<el-col :span="20" class="file_sub">
												<div>{{ item.contentList[0].fileName }}</div>
												<div class="fileSize">{{ item.contentList[0].fileSizeStr }}</div>
											</el-col>
											<el-col :span="4">
												<img :src="item.contentList[0].fileName | numfilters" class="fileName" />
											</el-col>
										</el-row>
										<div class="error-text" v-if="item.contentList[0].sendType == 3">
											发送失败，点击重试
										</div>
									</div>
									<div class="error-tip">
										<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
										<i
											class="el-icon-warning errorColor"
											v-if="item.contentList[0].sendType == 3"
											@click="repeatSendFileAction(item)"
										></i>
									</div>
								</div>
								<!-- 弹窗 -->
								<div v-else-if="item.contentList[0].type == 5"></div>
								<!-- 音频 -->
								<div v-else-if="item.contentList[0].type == 6" class="video_box">
									<audio-play :url="item.contentList[0].urls" :position="'left'"></audio-play>
									<div class="error-tip">
										<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
										<i
											class="el-icon-warning errorColor"
											v-if="item.contentList[0].sendType == 3"
											@click="repeatSendFileAction(item)"
										></i>
									</div>
								</div>
								<!-- 文本 -->
								<div
									class="content"
									v-else
									v-html="item.contentList[0].content"
									@mouseenter="mouseenter(index)"
									@mouseleave="mouseleave"
								></div>
							</div>
						</div>
						<!-- 自己发送的消息 -->
						<div class="chat-box-self" v-else>
							<div class="chat-content-self">
								<p style="text-align: right; height: 18px">
									<span style="font-size: 10px; margin-right: 15px" v-if="checkIndex == index">
										{{ item.sendTime }}
									</span>
									{{ item.fbName }}
								</p>
								<div v-if="item.contentList && item.contentList.length">
									<!--图片-->
									<div
										class="imgcontent-self"
										v-if="item.contentList[0].type == 2"
										@mouseenter="mouseenter(index)"
										@mouseleave="mouseleave"
									>
										<div class="error-tip">
											<div v-if="newOrold && userType != 1">
												<div v-if="item.readFlag == 1">
													<span class="read-font" v-if="textIndex == index">已读</span
													><i
														class="el-icon-circle-check"
														style="color: #999999"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
												<div v-else>
													<span class="read-font" v-if="textIndex == index">已送达</span
													><i
														class="no-read"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
											</div>
											<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
											<i
												class="el-icon-warning errorColor"
												@click="repeatSendFileAction(item)"
												v-if="item.contentList[0].sendType == 3"
											></i>
										</div>
										<div>
											<div v-if="imgFlag == index">
												<sky-img-preview
													:file="{
														url: item.contentList[0].urls,
														ossName: '8144864489269305344.png',
													}"
													file-name="AHHAH"
													:visible.sync="dialogVisible"
													title="查看图片"
													:img-url="item.contentList[0].urls"
													@on-cancel="showImg(index, -1)"
													:append="true"
												></sky-img-preview>
											</div>
											<img
												:src="item.contentList[0].urls"
												@click="showImg(index)"
												class="img-box-self"
											/>
											<div
												class="error-text"
												@click="repeatSendFileAction(item)"
												v-if="item.contentList[0].sendType == 3"
											>
												发送失败，点击重试
											</div>
										</div>
									</div>
									<!-- 视频 -->
									<div
										class="video_box"
										v-else-if="item.contentList[0].type == 3"
										@mouseenter="mouseenter(index)"
										@mouseleave="mouseleave"
									>
										<div class="error-tip">
											<div v-if="newOrold && userType != 1">
												<div v-if="item.readFlag == 1">
													<span class="read-font" v-if="textIndex == index">已读</span
													><i
														class="el-icon-circle-check"
														style="color: #999999"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
												<div v-else>
													<span class="read-font" v-if="textIndex == index">已送达</span
													><i
														class="no-read"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
											</div>
											<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
											<i
												class="el-icon-warning errorColor"
												@click="repeatSendFileAction(item)"
												v-if="item.contentList[0].sendType == 3"
											></i>
										</div>
										<div>
											<video
												ref="videoPlayer"
												controls
												:src="item.contentList[0].urls"
												class="video_content"
											></video>
											<div
												class="error-text"
												@click="repeatSendFileAction(item)"
												v-if="item.contentList[0].sendType == 3"
											>
												发送失败，点击重试
											</div>
										</div>
									</div>
									<!-- 文件 -->
									<div
										class="video_box"
										v-else-if="item.contentList[0].type == 4"
										@mouseenter="mouseenter(index)"
										@mouseleave="mouseleave"
									>
										<div class="error-tip">
											<div v-if="newOrold && userType != 1">
												<div v-if="item.readFlag == 1">
													<span class="read-font" v-if="textIndex == index">已读</span
													><i
														class="el-icon-circle-check"
														style="color: #999999"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
												<div v-else>
													<span class="read-font" v-if="textIndex == index">已送达</span
													><i
														class="no-read"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
											</div>
											<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
											<i
												class="el-icon-warning errorColor"
												@click="repeatSendFileAction(item)"
												v-if="item.contentList[0].sendType == 3"
											></i>
										</div>
										<div>
											<div
												class="file_style"
												@click="download(item.contentList[0].urls, item.contentList[0].fileName)"
											>
												<el-row>
													<el-col :span="20" class="file_sub">
														<div>{{ item.contentList[0].fileName | fileNameFilter }}</div>
														<div class="fileSize">{{ item.contentList[0].fileSizeStr }}</div>
													</el-col>
													<el-col :span="4">
														<img
															:src="item.contentList[0].fileName | numfilters"
															class="fileName"
														/>
													</el-col>
												</el-row>
											</div>
											<div
												class="error-text"
												v-if="item.contentList[0].sendType == 3"
												@click="repeatSendFileAction(item)"
											>
												发送失败，点击重试
											</div>
										</div>
									</div>
									<!-- 弹框 -->
									<div
										v-else-if="item.contentList[0].type == 5"
										style="display: flex; float: right"
									>
										<div class="error-tip" v-if="newOrold && userType != 1">
											<div v-if="item.readFlag == 1">
												<span class="read-font" v-if="textIndex == index">已读</span
												><i
													class="el-icon-circle-check"
													style="color: #999999"
													@mouseenter="textenter(index)"
													@mouseleave="textleave"
												></i>
											</div>
											<div v-else>
												<span class="read-font" v-if="textIndex == index">已送达</span
												><i
													class="no-read"
													@mouseenter="textenter(index)"
													@mouseleave="textleave"
												></i>
											</div>
										</div>
										<div class="popup-box" @mouseenter="mouseenter(index)" @mouseleave="mouseleave">
											<div class="underline">
												{{ JSON.parse(item.contentList[0].content)[0].content }}
											</div>
											<div
												style="
													display: flex;
													flex-direction: column;
													justify-content: center;
													align-items: center;
												"
											>
												<div
													v-if="
														JSON.parse(item.contentList[0].content)[1] &&
														JSON.parse(item.contentList[0].content)[1].content
													"
													class="button"
												>
													{{ JSON.parse(item.contentList[0].content)[1].content }}
												</div>
												<div
													v-if="
														JSON.parse(item.contentList[0].content)[2] &&
														JSON.parse(item.contentList[0].content)[2].content
													"
													class="button"
												>
													{{ JSON.parse(item.contentList[0].content)[2].content }}
												</div>
												<div
													v-if="
														JSON.parse(item.contentList[0].content)[3] &&
														JSON.parse(item.contentList[0].content)[3].content
													"
													class="button"
												>
													{{ JSON.parse(item.contentList[0].content)[3].content }}
												</div>
											</div>
										</div>
									</div>
									<!-- 音频 -->
									<div v-else-if="item.contentList[0].type == 6" class="video_box">
										<div class="error-tip">
											<div v-if="newOrold && userType != 1">
												<div v-if="item.readFlag == 1">
													<span class="read-font" v-if="textIndex == index">已读</span
													><i
														class="el-icon-circle-check"
														style="color: #999999"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
												<div v-else>
													<span class="read-font" v-if="textIndex == index">已送达</span
													><i
														class="no-read"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
											</div>
											<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
											<i
												class="el-icon-warning errorColor"
												v-if="item.contentList[0].sendType == 3"
												@click="repeatSendFileAction(item)"
											></i>
										</div>
										<audio-play :url="item.contentList[0].urls" :position="'right'"></audio-play>
									</div>
									<!-- 文本 -->
									<div v-else class="text-content">
										<div class="error-tip">
											<div v-if="newOrold && userType != 1">
												<div v-if="item.readFlag == 1" style="display: flex">
													<span class="read-font" v-if="textIndex == index">已读</span>
													<i
														class="el-icon-circle-check"
														style="color: #999999"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
												<div v-else style="display: flex">
													<span class="read-font" v-if="textIndex == index">已送达</span
													><i
														class="no-read"
														@mouseenter="textenter(index)"
														@mouseleave="textleave"
													></i>
												</div>
											</div>
											<i
												class="el-icon-warning errorColor"
												@click="repeatSendFileAction(item)"
												v-if="item.contentList[0].sendType == 3"
											></i>
										</div>

										<div
											class="content-self"
											v-html="item.contentList[0].content"
											@mouseenter="mouseenter(index)"
											@mouseleave="mouseleave"
										></div>
									</div>
								</div>
							</div>
							<div class="img-container">
								<img
									:src="require('@/assets/chat/sysDefault.png')"
									class="img"
									v-if="item.sendoutType == 1"
								/>
								<img :src="item.fbThumb || require('@/assets/default.png')" class="img" v-else />
							</div>
						</div>
					</div>
				</div>
			</el-scrollbar>
		</div>
	</div>
</template>
<script>
import audioPlay from '@/components/chat/components/audio-play.vue';
import skyImgPreview from '@/components/iglobalwin/formComponents/sky-img-preview.vue';
export default {
	props: {
		list: {
			type: Array,
		},
		firstTime: {
			type: String,
		},
		// time: {
		// 	type: String,
		// },
		endFlag: null,
		isbrowse: {
			type: Boolean,
			default: true,
		},
		userType: null,
		sourceTypeStr: null,
		moreTextFlag: null,
		scollFlag: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			imgFlag: -1,
			dd: 0,
			hh: '00',
			mm: '00',
			ss: '00',
			flag: false,
			showTime: false,
			checkIndex: -1,
			dialogVisible: false,
			moreText: '查看更多消息...',
			displayStart: 1,
			moreFlag: true,
			height: 0,
			textIndex: -1,
		};
	},
	filters: {
		fileNameFilter(value) {
			let len = value.length;
			if (!value) return '';
			if (value.length > 20) {
				return value.substring(0, 12) + '...' + value.substring(len - 12, len);
			}
			return value;
		},
		numfilters(val) {
			const typeList = {
				xls: {
					img: 'xls.png',
				},
				xlsx: {
					img: 'xls.png',
				},
				txt: {
					img: 'txt.png',
				},
				pdf: {
					img: 'pdf.png',
				},
				doc: {
					img: 'word.png',
				},
				docx: {
					img: 'word.png',
				},
				zip: {
					img: 'zip.png',
				},
				ppt: {
					img: 'ppt.png',
				},
				pptx: {
					img: 'ppt.png',
				},
				rar: {
					img: 'rar.png',
				},
				others: {
					img: 'o-file.png',
				},
				// mp4: {
				// 	img: 'file.png',
				// },
			};
			const type = val.substring(val.lastIndexOf('.') + 1).toLowerCase(); // 截取的图片类型
			return type && typeList[type]
				? require(`@/assets/${typeList[type].img}`)
				: require(`@/assets/${typeList['others'].img}`);
		},
	},
	watch: {
		list: {
			handler() {
				//每次改变的时候都会到底部，点击查看更多
				this.$nextTick(() => {
					if (!this.scollFlag) {
						this.$refs['myScrollbar'].wrap.scrollTop = this.$refs['myScrollbar'].wrap.scrollHeight;
					} else {
						this.$refs['myScrollbar'].wrap.scrollTop =
							this.$refs['myScrollbar'].wrap.scrollHeight - this.height;
					}
				});
			},
			deep: true,
			immediate: true,
		},
		// scollFlag: {
		// 	handler(val) {
		// 		if (!val) {
		// 			console.log('list滚动----', this.$refs['myScrollbar'].wrap.scrollTop);
		// 			// this.$nextTick(() => {
		// 			// this.$refs['myScrollbar'].wrap.scrollTop = this.$refs['myScrollbar'].wrap.scrollHeight;
		// 			// });
		// 		}
		// 	},
		// 	deep: true,
		// 	immediate: true,
		// },
		endFlag: {
			deep: true,
			immediate: true,
			handler() {
				if (this.endFlag == 1) {
					this.hh = '00';
				}
				this.mm = '00';
				this.ss = '00';
				this.dd = '';
			},
		},
		firstTime: {
			deep: true,
			immediate: true,
			handler() {
				this.flag = false;

				let time = setInterval(() => {
					if (this.flag) {
						// this.$store.commit('SET_REFRESHFLAG', false);
						clearInterval(time);
						this.hh = '00';
						this.mm = '00';
						this.ss = '00';
						this.dd = '';
					}
					if (this.endFlag != 1) {
						this.timeDown();
					}
				}, 500);
			},
		},
	},
	computed: {
		userTypeStr() {
			return this.userType == 1 ? '第一条' : '最后一条';
		},

		newOrold() {
			return this.$route.name !== 'liveChat';
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.$refs['myScrollbar'].wrap.scrollTop = this.$refs['myScrollbar'].wrap.scrollHeight;
		});
	},
	methods: {
		textenter(index) {
			this.textIndex = index;
		},
		textleave() {
			this.textIndex = -1;
		},
		showImg(index, flag) {
			if (flag) {
				this.imgFlag = flag;
				this.dialogVisible = false;
			} else {
				this.imgFlag = index;
				this.dialogVisible = true;
			}
		},
		more() {
			this.height = this.$refs['myScrollbar'].wrap.scrollHeight;
			let recordId = this.list[0].recordId;
			let sendTime = this.list[0].sendTime;
			++this.displayStart;
			this.$emit('more', this.displayStart, recordId, sendTime);
		},
		download(url, name) {
			const a = document.createElement('a');
			a.style.display = 'none';
			// 这里是将url转成blob地址，
			let urlstr;
			if (url.indexOf('https') == -1) {
				urlstr = url.slice(0, 4) + 's' + url.slice(4);
			} else {
				urlstr = url;
			}
			// window.open(urlstr);
			fetch(urlstr)
				.then(res => res.blob())
				.then(blob => {
					// 将链接地址字符内容转变成blob地址
					a.href = URL.createObjectURL(blob);
					a.download = name; // 下载文件的名字
					document.body.appendChild(a);
					a.click();
				});
		},
		timeDown() {
			let time;
			if (this.userType == 1) {
				time = 24 * 60 * 60 * 1000;
			} else {
				time = 7 * 24 * 60 * 60 * 1000;
			}
			const endTime = Date.parse(new Date(this.firstTime)) + time;
			const nowTime = Date.parse(new Date(this.firstTime));
			var date = new Date();
			var now = date.getTime(nowTime);
			//设置截止时间
			var endDate = new Date(endTime);
			var end = endDate.getTime();
			//时间差
			var rightTime = end - now; //截止时间减去当前时间
			if (rightTime > 0) {
				//判断剩余倒计时时间如果大于0就执行倒计时否则就结束
				var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
				var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
				var mm = Math.floor((rightTime / 1000 / 60) % 60);
				var ss = Math.floor((rightTime / 1000) % 60);
				this.hh = hh;
				this.mm = mm;
				this.ss = ss;
				this.dd = dd;
				// this.$store.commit('SET_REFRESHFLAG', true);
			} else {
				this.flag = true;
				// this.$store.commit('SET_REFRESHFLAG', false);
			}
		},
		mouseenter(index) {
			this.checkIndex = index;
		},
		mouseleave() {
			this.checkIndex = -1;
		},
		resend() {},
		repeatSendFileAction(item) {
			this.$emit('repeatSendFileAction', item);
		},
	},
	components: {
		skyImgPreview,
		audioPlay,
	},
};
</script>
<style lang="scss" scoped>
.chat {
	// height: 600px;
	height: calc(100vh - 205px);
	overflow-x: hidden;
	.content-box {
		// margin-top: 15px;
		height: calc(100vh - 260px);
		overflow-x: hidden;
	}
	::v-deep .el-scrollbar__wrap {
		overflow-x: hidden;
	}
}
.timeTip_box {
	position: relative;
	text-align: center;
}
.timeTip {
	display: inline-block;
	text-align: center;
	height: 30px;
	background: #fff4c8;
	border-radius: 4px;
	font-weight: 400;
	color: #f89d29;
	font-size: 12px;
	text-align: center;
	line-height: 30px;
	padding: 0px 10px;
	margin: 20px auto 0px auto;
}
.img-container {
	width: 40px;
}
.chat-box {
	width: 50%;
	margin-bottom: 30px;
	text-align: left;
	display: flex;

	.content {
		// width:50%;

		display: inline-block;
		margin-top: 10px;
		padding: 11px 15px;
		background: #f9f9f9;
		box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
		border-radius: 6px;
	}
	.chat-content {
		display: inline-block;
		margin-left: 10px;
	}
}
.chat-box-self {
	display: flex;
	width: 50%;
	margin-left: 50%;
	justify-content: flex-end;
	margin-bottom: 30px;
	.text-content {
		display: flex;
	}
	.read-font {
		width: 50px;
		color: #999999;
	}
	.no-read {
		display: inline-block;
		border: 1px #3da1ff solid;
		border-radius: 50%;
		width: 13px;
		height: 13px;
		margin-top: 3px;
	}
	.content-self {
		word-break: break-all;
		margin-top: 10px;
		padding: 11px 15px;
		background: #c6e5ff;
		color: #000;
		box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
		border-radius: 6px;
	}
	.chat-content-self {
		margin-right: 10px;
	}
}
.img {
	width: 40px;
	height: 40px;
	background: #d3d6db;
	border-radius: 20px;
	object-fit: contain;
	display: inline-block;
	vertical-align: top;
}
.video_box {
	display: flex;
	margin-top: 10px;
	.video_content {
		width: 250px;
		height: 180px;
		// object-fit: fill;
		border-radius: 10px;
	}
}
.file_style {
	width: 260px;
	max-height: 100px;
	// height: 80px;
	background: #ffffff;
	border-radius: 6px;
	border: 1px solid #e8e8e8;
	padding: 15px;
	.file_sub {
		word-wrap: break-word;
		display: block;
		.fileSize {
			margin-top: 10px;
		}
	}
	.fileName {
		width: 35px;
		height: 40px;
	}
}
.imgcontent-self {
	margin-top: 10px;
	display: flex;
	width: 260px;
	flex-direction: row;
	justify-content: flex-end;
	.img-box-self {
		cursor: pointer;
		max-width: 250px;
		max-height: 200px;
		// object-fit: contain;
		// float: right;
	}
}
.imgcontent {
	// display: flex;
	// display: inline-block;
	margin-top: 10px;
	.img-box {
		cursor: pointer;
		max-width: 250px;
		max-height: 200px;
		object-fit: contain;
	}
	.img-box-self {
		float: right;
	}
}
.moreText {
	font-size: 10px;
	text-align: center;
	color: #3da1ff;
	cursor: pointer;
	padding-top: 5px;
}
.greyMoreText {
	font-size: 10px;
	text-align: center;
	color: #666666;
	padding-top: 5px;
}
.error-tip {
	width: 150px;
	padding-right: 10px;
	display: flex;
	align-items: center;
	justify-content: right;
}
.error-text {
	color: red;
	padding: 10px;
	font-size: 12px;
}
.errorColor {
	cursor: pointer;
	color: red;
}
.popup-box {
	max-width: 250px;
	margin-top: 10px;
	padding: 11px 15px;
	background: #c6e5ff;
	color: #000;
	box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
	border-radius: 6px;
	.underline {
		padding-bottom: 10px;
		border-bottom: 1px #ffffff solid;
	}
	.button {
		text-align: center;
		width: 150px;
		margin-top: 10px;
		padding: 5px 10px;
		// border: 1px #ffffff solid;
		background: #ffffff;
		border-radius: 6px;
	}
}
</style>
